import { CaretDown } from '../icons'
import { Transition } from '@headlessui/react'
import { useState } from 'react'

export default function ContentDisclosure({ button, content }) {
	const [open, setOpen] = useState(false)

	return (
		<div
			className={`${open ? 'bg-uiTertiaryLight dark:bg-uiTertiaryDark' : ''} transition-height duration-300 ease-in-out ${open ? 'h-full' : 'h-14'}`}
		>
			<div
				className={`transition-bg group flex w-full cursor-pointer items-center justify-between rounded-md pr-4 duration-300 ease-in-out hover:bg-uiTertiaryLight dark:hover:bg-uiTertiaryDark`}
				onClick={e => setOpen(!open)}
			>
				{button}
				<CaretDown
					className={`${
						open ? 'rotate-180 transform' : ''
					} h-6 w-6 text-textSecondaryLight dark:text-textSecondaryDark`}
				/>
			</div>
			<Transition
				show={open}
				enter="transition-all duration-300 ease-in-out"
				enterFrom="opacity-0 h-0"
				enterTo="opacity-100 h-full"
			>
				<div
					className={`bg-uiTertiaryLight px-4 pb-4 pt-4 dark:bg-uiTertiaryDark`}
				>
					{content}
				</div>
			</Transition>
		</div>
	)
}
